import type { PhotoSessionSection } from "./photoSessionUtils";
import type { PhotoCarGuide } from "./carGuideTypes";
import {
  EXTERIOR_GUIDED_COUNT,
  getExteriorGuideForPhotoIndex,
} from "./exteriorCarGuides";
import {
  INTERIOR_GUIDED_COUNT,
  getInteriorGuideForPhotoIndex,
} from "./interiorCarGuides";
import type { GuideFrameMode } from "./PhotoSessionCameraView";
import { resolvePhotoSessionGuideLabels } from "./photoSessionGuideLabels";

export function getGuideForPhotoIndex(
  section: PhotoSessionSection,
  photoIndex: number,
): {
  activeGuide: PhotoCarGuide | null;
  guideFrameMode: GuideFrameMode;
} {
  const guidedCount =
    section === "exterior"
      ? EXTERIOR_GUIDED_COUNT
      : section === "interior"
        ? INTERIOR_GUIDED_COUNT
        : 0;

  const activeGuide =
    section === "exterior"
      ? getExteriorGuideForPhotoIndex(photoIndex)
      : section === "interior"
        ? getInteriorGuideForPhotoIndex(photoIndex)
        : null;

  const guideFrameMode: GuideFrameMode = activeGuide
    ? "guided"
    : (section === "exterior" || section === "interior") &&
        photoIndex > guidedCount
      ? "optional"
      : "none";

  return { activeGuide, guideFrameMode };
}

export function resolveLabelsForPhotoIndex(
  section: PhotoSessionSection,
  sectionTitle: string,
  photoIndex: number,
  maxForSection: number,
  labels: {
    exteriorGuides?: Record<string, string>;
    interiorGuides?: Record<string, string>;
    exteriorGuideStep?: string;
    interiorGuideStep?: string;
    guidedOptionalHint?: string;
    exteriorOptionalHint?: string;
    guidedOptionalSub?: string;
    exteriorOptionalSub?: string;
    sectionShotTitle?: string;
    landscapeGuide: string;
    landscapeFormatHint: string;
  },
) {
  const { activeGuide } = getGuideForPhotoIndex(section, photoIndex);
  return resolvePhotoSessionGuideLabels({
    section,
    sectionTitle,
    nextPhotoIndex: photoIndex,
    maxForSection,
    activeGuide,
    ...labels,
  });
}
